export default __webpack_public_path__ + "static/barlow-v4-latin-600-6c9206ba0895a22a4b098f3a598a3e55.ttf";